module.exports = __webpack_public_path__ + "media/hyper/images/flags/germany-be5eb19fc155de5bbbff967b8920166e.jpg";